import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingPage } from '../../../compartido/cargando/loading';
import { ConfirmationService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { Constantes } from '../../../compartido/constantes/constantes';
import { ConfiguracionGeneralService } from 'npm-servicios-catering';
import { ConfiguracionGeneral } from 'npm-modelado-catering';

@Component({
  selector: 'app-configuracion-parametros',
  templateUrl: './configuracion-parametros.component.html',
  styleUrls: ['./configuracion-parametros.component.css']
})
export class ConfiguracionParametrosComponent extends LoadingPage implements OnInit {

  constructor(private router: Router,
    private confirmationService: ConfirmationService, private configuracionGeneralService: ConfiguracionGeneralService) { super(false); }

  busy: Subscription;
  enEdicionTiempoLimiteConfirmar: boolean = false;
  /***********************************************/
  limiteConfirmarValor: number = 0;
  limiteConfirmarDescripcion: string = "";
  lstConfiguraciones: any;
  selectConfiguracion: ConfiguracionGeneral;

  tiempoLimiteConfirmar: ConfiguracionGeneral;

  ngOnInit() {
    this.cargarEnviroment();
    this.obtenerConfiguracionParametros();

  }
  obtenerConfiguracionParametros() {
    this.busy = this.configuracionGeneralService.listar().then(conf => {
      if (conf) {
        this.lstConfiguraciones = conf;
      }
    }).catch(error => {
      this.mostrarMensajeError("No se encuentra disponible el servicio de listar configuraciones, intente más adelante refrescando la pestaña o comuníquese con el administrador");
    });
  }

  buscarLimiteConfirmarServicio() {
    this.busy = this.configuracionGeneralService.buscarConfiguracionGeneralObjectPorTipo(Constantes.TIPO_CONFIGURACION_CONFIRMAR).then(conf => {
      if (conf) {
        this.tiempoLimiteConfirmar = conf;
        this.limiteConfirmarValor = this.tiempoLimiteConfirmar.valor;
        this.limiteConfirmarDescripcion = this.tiempoLimiteConfirmar.descripcion;
        console.log(this.limiteConfirmarValor);
      } else {
        this.mostrarMensajeInfo("No se puede configurar el tiempo límite por que no existe el parámetro");
      }
    }).catch(error => {
      this.mostrarMensajeError(error);
    });
  }

  tiempoLimiteConfirmarServicioEditarClick() {
    if (this.selectConfiguracion) {
      this.router.navigate(['/configuracion/configuracion-parametros-editar/'],
        { queryParams: { id: this.selectConfiguracion.idConfiguracionCatering } });
    } else {
      this.mostrarMensajeInfo("Debe seleccionar un registro");
    }
  }
  tiempoLimiteConfirmarServicioCancelarClick() {
    this.enEdicionTiempoLimiteConfirmar = false;
    this.limiteConfirmarValor = this.tiempoLimiteConfirmar.valor;
    this.limiteConfirmarDescripcion = this.tiempoLimiteConfirmar.descripcion;
  }
  cargarEnviroment() {
    this.configuracionGeneralService.set_constantes(Constantes);
  }
  redirectListado() {
    this.router.navigate(['/configuracion/configuracion-parametros/']);
  }

  /*actualizaConfiguracion() {
    this.busy = this.configuracionGeneralService.actualizar(this.configuracionGuardar).then(response => {
      if (response) {
        this.mostrarMensajeInfo("Proceso realizado con éxito");
        this.obtenerSubCategoriasPorCategoria(this.selectCategoria.idCategoria);

        if (this.imagenSubCategoriaSeleccionada) {
          this.imagenSubCategoriaSeleccionada = null;
        }
        this.pathImagenSubCategoria = this.subCategoriaGuardar.pathFoto + new Date().toString();;
        this.showGuardando = false;
      }
    }).catch(error => {
      this.mostrarMensajeError(error);
    });
  }*/

}
